import React, { useState } from "react";
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import ConfirmationDialog from "../ConfirmationDialog/ConfirmationDialog";
import styles from "./FileListElement.module.css";

type FileListElementProps = {
  file: File;
  onRemoveClicked: (name: string) => void;
};

function FileListElement({ file, onRemoveClicked }: FileListElementProps) {
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);

  const openDeleteDialog = (e?: React.MouseEvent) => {
    e?.preventDefault();
    setDeleteDialogVisible(true);
  };

  const onDelete = () => {
    onRemoveClicked(file.name);
    setDeleteDialogVisible(false);
  };

  return (
    <div className={styles["file-list-element"]}>
      <Icon name="Paper_clip" />
      <p title={file.name}>{file.name}</p>

      {}
      <Button
        type="button"
        variant="transparent"
        icon="Trash"
        size="extra-small"
        onClick={openDeleteDialog}
      />

      <ConfirmationDialog
        title={`Delete attachment`}
        info={`Do you want to delete: ${file.name}`}
        submitIcon="Trash"
        submitText="Delete"
        onSubmit={onDelete}
        visible={deleteDialogVisible}
        setVisible={setDeleteDialogVisible}
      />
    </div>
  );
}

export default FileListElement;
